import {lightningBoltSvg as Icon__small__lightningBoltSvg} from '../Icon__small/Icon__small--lightningBolt.js';

export var lightningBolt = {
  name: 'lightningBolt',
  category: 'icon',
  colorable: true,
  svg: Icon__small__lightningBoltSvg,
};
